module.exports = __webpack_public_path__ + "img/truck-front.8856f441.svg";